import React, { useMemo } from 'react';
import classNames from 'classnames/bind';
import { Tabs, Text } from '@beef/ui-kit';
import { RecommendationProductsSkeleton } from "./Skeleton";
import RecommendationProductsList from "./components/RecommendationProductsList";
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
var DEFAULT_SKELETON_ITEMS_COUNT = 4;
var RecommendationsLayout = function RecommendationsLayout(_ref) {
  var label = _ref.label,
    _ref$labelTag = _ref.labelTag,
    labelTag = _ref$labelTag === void 0 ? 'p' : _ref$labelTag,
    tabs = _ref.tabs,
    _ref$onChangeTab = _ref.onChangeTab,
    onChangeTab = _ref$onChangeTab === void 0 ? function () {} : _ref$onChangeTab,
    _ref$tabVariant = _ref.tabVariant,
    tabVariant = _ref$tabVariant === void 0 ? 'custom' : _ref$tabVariant,
    devicesStatus = _ref.devicesStatus,
    tabsStatus = _ref.tabsStatus,
    _ref$skeletonItemsCou = _ref.skeletonItemsCount,
    skeletonItemsCount = _ref$skeletonItemsCou === void 0 ? DEFAULT_SKELETON_ITEMS_COUNT : _ref$skeletonItemsCou,
    _ref$showSliderArrow = _ref.showSliderArrow,
    showSliderArrow = _ref$showSliderArrow === void 0 ? false : _ref$showSliderArrow,
    _ref$captionSize = _ref.captionSize,
    captionSize = _ref$captionSize === void 0 ? 'size2-m' : _ref$captionSize,
    _ref$maxSlides = _ref.maxSlides,
    maxSlides = _ref$maxSlides === void 0 ? 4 : _ref$maxSlides,
    children = _ref.children,
    onInit = _ref.onInit,
    sendYm = _ref.sendYm,
    sliderSettings = _ref.sliderSettings,
    noPadding = _ref.noPadding;
  var selectedTab = useMemo(function () {
    return tabs && tabs.find(function (tab) {
      return tab.isActive;
    });
  }, [tabs]);
  if (devicesStatus === 'loading' && tabsStatus === 'loading') {
    return /*#__PURE__*/React.createElement(RecommendationProductsSkeleton, {
      skeletonItemsCount: skeletonItemsCount
    });
  }
  var isError = devicesStatus === 'error' || tabsStatus === 'error' || !devicesStatus;
  if (isError) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, !!(label !== null && label !== void 0 && label.length) && /*#__PURE__*/React.createElement(Text, {
    size: captionSize,
    tagType: labelTag
  }, label), !!(tabs !== null && tabs !== void 0 && tabs.length) && /*#__PURE__*/React.createElement("div", {
    className: cn('tab-wrapper')
  }, /*#__PURE__*/React.createElement(Tabs, {
    isScrollable: true,
    noWrap: true,
    onChange: onChangeTab,
    selectedTab: selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.id,
    tabs: tabs,
    variant: tabVariant
  })), /*#__PURE__*/React.createElement(RecommendationProductsList, {
    maxSlides: maxSlides,
    noPadding: noPadding,
    onInit: onInit,
    sendYm: sendYm,
    showSliderArrow: showSliderArrow,
    skeletonItemsCount: skeletonItemsCount,
    sliderSettings: sliderSettings,
    status: devicesStatus
  }, children));
};
export { RecommendationsLayout };